export interface SettingsTranslationRequestDto {
    id: string;
    translation: string;
}
